function replaceNorwegianCharacters(word) {
  // Define a map of Norwegian characters and their English equivalents
  const characterMap = {
    æ: 'ae',
    ø: 'o',
    å: 'a',
    Æ: 'AE',
    Ø: 'O',
    Å: 'A',
  };

  // Use a regular expression with a callback function to replace characters
  const replacedWord = word.replace(/[æøåÆØÅ]/g, (match) => characterMap[match] || match);

  return replacedWord;
}

export const fallbackImagePath = (city, useLargeImage = true) => {
  if (!city) return null;
  city = replaceNorwegianCharacters(city);

  const imageSize = useLargeImage ? 'large' : 'small';

  return `/-/jssmedia/Project/Hedin/Shops/BavariaNoSite/Forhandlere/${imageSize}/${city}.jpg`;
};
